import { jsxs as h, jsx as l } from "react/jsx-runtime";
import { E as u, S as _ } from "./icons.types-0722eef5.js";
function m({ title: n, titleId: o, size: i, width: c, height: s, extended: r = !1, ...t }) {
  const e = r ? u : _, d = i ? e[i] : c || e[r ? "s" : "l"], a = i ? e[i] : s || e[r ? "s" : "l"];
  return /* @__PURE__ */ h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: d,
      height: a,
      "aria-labelledby": o,
      ...t,
      children: [
        n ? /* @__PURE__ */ l("title", { id: o, children: n }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Question_mark__Filled_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm-2.459 47.555c-2.604 0-4.475 1.702-4.475 4.225 0 2.529 1.87 4.282 4.475 4.282 2.61 0 4.475-1.753 4.475-4.282 0-2.523-1.864-4.225-4.475-4.225Zm4.525-34.617c-6.514 0-11.873 2.243-17.16 6.118l4.193 4.69c3.939-3.187 7.674-5.186 12.317-5.186 4.584 0 6.84 2.121 6.84 5.122 0 2.814-1.294 4.312-5.48 6.998l-.776.501c-4.968 3.187-6.839 4.784-6.839 10.593h5.42c.126-2.564 1.16-3.968 4.835-6.03l.908-.502c5.805-3.251 8.77-6.124 8.77-11.56 0-6.124-5.029-10.744-13.028-10.744Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Question_mark__Filled_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  m as QuestionMarkFilled
};
